import { getCountries } from '@/api/country'
import LoadableModel from '@/models-ts/LoadableModel'

const getInitialState = () => ({
  list: new LoadableModel(),
})

export default () => ({
  namespaced: true,
  state: getInitialState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitialState())
    },
    beforeReady(state) {
      state.list = new LoadableModel(state.list)
    },
    setListLoading(state) {
      state.list.loading()
    },
    setListLoaded(state, data) {
      state.list.loaded(data)
    },
  },
  actions: {
    async getCountries({ state, commit }) {
      if (state.list.isLoaded) {
        return state.list.value
      }
      commit('setListLoading')
      const list = await getCountries()
      commit('setListLoaded', list)
      return list
    },
  },
})
